import { useState, useEffect, useMemo } from "react";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import ReactPaginate from "react-paginate";

const authUrl = process.env.REACT_APP_API_ENDPOINT_AUTH;
const jobsUrl = process.env.REACT_APP_API_ENDPOINT_JOBS;
const clientId = process.env.REACT_APP_API_CLIENT_ID;
const secret = process.env.REACT_APP_API_SECRET;

function App() {
  const [showLoader, setShowLoader] = useState(false);
  const [jobs, setJobs] = useState([]);
  const [jobPositionCity, setJobPositionCity] = useState([]);
  const [selectedCityId, setSelectedCityId] = useState("");
  const [jobPositionTitle, setJobPositionTitle] = useState([]);
  const [selectedTitleId, setSelectedTitleId] = useState("");
  const [showMenu, setShowMenu] = useState(false);

  // paginação vagas efetivas
  const itemsPerPage = 3;
  const [itemOffsetEffectiveJobs, setItemOffsetEffectiveJobs] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);

  const endOffsetEffectiveJobs = itemOffsetEffectiveJobs + itemsPerPage;

  const filteredJobs = useMemo(() => {
    return jobs.filter((job) => {
      const matchesCity =
        !selectedCityId || job.cityId === Number(selectedCityId);

      const matchesTitle =
        !selectedTitleId || job.titlePositionId === Number(selectedTitleId);

      return matchesCity && matchesTitle;
    });
  }, [jobs, selectedCityId, selectedTitleId]);

  const currentEffectiveJobs = filteredJobs.slice(
    itemOffsetEffectiveJobs,
    endOffsetEffectiveJobs,
  );
  const pageCountEffectiveJobs = Math.ceil(filteredJobs.length / itemsPerPage);

  const handlePageClickEffectiveJobs = (event) => {
    const newOffset = (event.selected * itemsPerPage) % filteredJobs.length;
    setItemOffsetEffectiveJobs(newOffset);
    setCurrentPage(event.selected);

    document.getElementById("oportunidades").scrollIntoView();
  };

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };

  const generateNonce = () => {
    const nonce = Math.floor(Math.random() * 1000000000);
    return nonce;
  };

  const generateTimestamp = () => {
    const timestamp = Math.floor(Date.now() / 1000).toString();
    return timestamp;
  };

  const onChangeFilterJobsCity = ($event) => {
    setItemOffsetEffectiveJobs(0);
    setCurrentPage(0);

    setSelectedCityId($event.target.value);
  };

  const onChangeFilterJobsTitle = ($event) => {
    setItemOffsetEffectiveJobs(0);
    setCurrentPage(0);

    setSelectedTitleId($event.target.value);
  };

  useEffect(() => {
    const fetchData = async () => {
      setShowLoader(true);

      let retries = 0;
      let success = false;

      while (retries <= 2 && !success) {
        try {
          let token = localStorage.getItem("api_token");
          let storedNonce =
            localStorage.getItem("api_nonce") || generateNonce();
          let storedTimestamp =
            localStorage.getItem("api_timestamp") || generateTimestamp();

          if (!token) {
            const authResponse = await fetch(`${authUrl}`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "X-Nonce": storedNonce,
                "X-Timestamp": storedTimestamp,
              },
              body: JSON.stringify({
                clientId: clientId,
                secret: secret,
              }),
            });

            if (!authResponse.ok) throw new Error("Erro na autenticação");

            const authData = await authResponse.json();
            token = authData.token;

            localStorage.setItem("api_token", token);
            localStorage.setItem("api_nonce", storedNonce);
            localStorage.setItem("api_timestamp", storedTimestamp);
          }

          const dataResponse = await fetch(`${jobsUrl}`, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
              "X-Target": "pharlab",
              "X-Nonce": storedNonce,
              "X-Timestamp": storedTimestamp,
            },
          });

          if (dataResponse.status === 401) {
            localStorage.clear();

            retries++;
            continue;
          }

          if (!dataResponse.ok) throw new Error("Erro ao buscar dados");

          const jobsData = await dataResponse.json();

          setJobs(jobsData.jobPositionList);
          setJobPositionCity(jobsData.cityList);
          setJobPositionTitle(jobsData.titlePositionList);

          success = true;
        } catch (error) {
          console.error("Erro no fluxo:", error);
          retries++;
        }
      }

      setShowLoader(false);
    };

    fetchData();
  }, []);

  return (
    <div>
      <nav className="bg-[#0F1941] h-24">
        <div className="flex items-center justify-between p-4 pr-[10%] relative max-[768px]:justify-center">
          <div>
            <img
              src="./assets/icons/randstad-logo.png"
              alt="Randstad Logo"
              className="h-26"
            />
          </div>

          <ul
            id="content-burger-menu"
            className={`${"flex flex-row justify-end items-center gap-16 list-meu w-1/2"} ${
              showMenu ? "show" : ""
            }`}
          >
            <li>
              <a href="#sobre" className="text-white">
                sobre nós
              </a>
            </li>
            <li>
              <a href="#oportunidades" className="text-white">
                oportunidades
              </a>
            </li>
            <li className="pr-[10%]">
              <a
                href="https://www.randstad.com.br/contate-nos/contato-candidato/"
                target="_blank"
                className="text-white"
                rel="noreferrer"
              >
                contato
              </a>
            </li>
          </ul>
        </div>
      </nav>

      <div className="w-full h-auto bg-[#2074D9] flex justify-center items-center max-[768px]:flex-col-reverse">
        <div
          id="main-title"
          className="flex flex-col pl-[5%] z-10 w-1/2 gap-8 max-[768px]:w-full max-[768px]:gap-2"
        >
          <div>
            <p className="text-white text-[5vw] mb-0 leading-none max-[768px]:text-[10vw]">
              venha fazer parte
            </p>
            <p className="text-white text-[5vw] ml-[10%] mb-0 leading-none max-[768px]:text-[10vw]">
              da nossa equipe!
            </p>
          </div>
          <div className="w-full flex justify-center my-5">
            <img
              src="./assets/images/logo-white.svg"
              alt="Pharlab Landing Page"
              className="w-[50%] rounded-none max-[768px]:w-[80%]"
            />
          </div>
        </div>
        <div className="w-1/2 max-[768px]:w-full">
          <img
            src="./assets/images/pharlab-mask.png"
            alt="Pharlab Landing Page"
            className="w-full rounded-none max-[768px]:hidden"
          />
          <img
            src="./assets/images/pharlab-mask-mobile.png"
            alt="Pharlab Landing Page"
            className="w-full rounded-none min-[768px]:hidden"
          />
        </div>
      </div>

      <div className="flex flex-wrap w-full bg-white py-14 px-[7vw]">
        <h1 className="text-3xl text-blue-500 mb-6">
          a parceria entre Pharlab e Randstad
        </h1>
        <div
          id="parceria"
          className="w-full flex flex-col gap-6 max-[768px]:flex-col"
        >
          <div className="w-full flex">
            <p className="text-black text-lg">
              A Pharlab, em parceria com a Randstad, líder global em
              recrutamento e soluções de recursos humanos, presente em mais de
              39 países pelo mundo, uniu forças para garantir um processo
              seletivo que além de selecionar talentos, também apresente como é
              trabalhar em
              <span className="text-[#2175D9]">
                {" "}
                uma empresa farmacêutica brasileira especializada na fabricação
                de medicamentos genéricos
              </span>
              , similares e produtos de saúde.
            </p>
          </div>
          <div className="flex items-center justify-center w-full gap-[15%] max-[768px]:flex-col">
            <img
              src="./assets/images/logo.svg"
              alt="Logo"
              className="w-[30%] max-[768px]:w-[90%] max-[768px]:mb-5"
            />
            <img
              src="./assets/images/logo-randstad.svg"
              alt="Logo Randstad"
              className="w-[17%] max-[768px]:w-[60%]"
            />
          </div>
        </div>
      </div>

      <div
        className="flex w-full gap-6 px-[7vw] max-[768px]:flex-col !pt-0"
        id="sobre"
      >
        <div className="flex flex-col w-full max-[768px]:w-full">
          <h1 className="text-3xl text-blue-500 mb-4">sobre a Pharlab</h1>
          <p className="text-lg text-black mb-6">
            Há mais de 20 anos fazendo parte de um dos maiores ecossistemas de
            saúde no Brasil. Com a força e a experiência de uma multinacional
            francesa, a Pharlab está próxima de cada cliente e entende as
            diferenças socioculturais de cada região onde atua. <br />
            <span className="text-lg text-[#2175D9]">
              Possui uma ampla linha de produtos que abrange diversas áreas
              terapêuticas, como cardiovascular, gastroenterologia, neurologia,
              ginecologia, entre outras.
            </span>
          </p>
          <p className="text-lg text-black mb-6">
            Você pode confiar em toda a linha de genéricos, equivalentes de
            marca, isentos de prescrição e suplementos alimentares.
          </p>
        </div>
      </div>

      <div className="flex flex-wrap justify-center px-[7vw] max-[768px]:flex-col">
        <img
          src="./assets/images/feature-01.svg"
          alt="Banner 01"
          className="w-[33.33%] max-[768px]:w-full"
        />
        <img
          src="./assets/images/feature-02.svg"
          alt="Banner 01"
          className="w-[33.33%] max-[768px]:w-full"
        />
        <img
          src="./assets/images/feature-03.svg"
          alt="Banner 01"
          className="w-[33.33%] max-[768px]:w-full"
        />
      </div>

      <div
        className="flex w-full justify-between pl-[7vw] max-[768px]:flex-col max-[768px]:px-[7vw] !pt-0"
        id="missao"
      >
        <div className="flex flex-col w-1/2 max-[768px]:w-full">
          <h1 className="text-3xl text-blue-500 mb-4">missão Pharlab</h1>
          <p className="text-lg text-black mb-6">
            Fornecer soluções farmacêuticas de qualidade, acessíveis e
            inovadoras, com o objetivo de contribuir para a saúde e o bem-estar
            das pessoas. A empresa busca desenvolver e fabricar medicamentos
            seguros e eficazes, seguindo rigorosos padrões de qualidade e boas
            práticas de fabricação.
          </p>
          <p className="text-lg text-black mb-6">
            Além disso, tem o compromisso de investir em pesquisas e
            desenvolvimento, buscando constantemente novas tecnologias e
            soluções terapêuticas.
            <span className="text-lg text-[#2175D9]">
              {" "}
              A empresa acredita na importância da inovação para atender às
              necessidades dos pacientes e proporcionar tratamentos mais
              eficazes.
            </span>
          </p>
        </div>

        <div className="w-1/2 flex justify-end mt-[8vh] max-[768px]:w-full">
          <img
            src="./assets/images/banner-02.png"
            alt="Imagem Outdoor"
            className="w-[90%] rounded-none max-[768px]:w-full"
          />
        </div>
      </div>

      <div className="w-full flex flex-col justify-center max-[768px]:items-center px-[7vw] max-[768px]:mt-14 mt-8">
        <h1 className="text-3xl text-blue-500 mb-4">alguns diferenciais</h1>
        <p className="text-lg text-black mb-4">
          Alguns benefícios que você terá trabalhando na Pharlab através da
          Randstad:
        </p>
        <div className="flex gap-4 text-lg text-black mb-4 max-[768px]:flex-col">
          <ul className="list-disc list-inside">
            <li>Vale Alimentação de R$ 490,00</li>
            <li>Duas opções de assistência médica on-line sem custo.</li>
            <li>Seguro de Vida</li>
          </ul>
          <ul className="list-disc list-inside">
            <li>
              Gogood: Planos de atividades físicas (academias, Pilates), para
              colaboradores e dependentes com mensalidade para funcionários a
              partir de R$39,00 e dependentes a partir de 79,00. Atualmente
              existem 3 planos: Básico, Standard e Premium
            </li>
            <li>
              Medicamentos da linha de produção, através da apresentação de
              receita médica, os descontos serão de 100% para colaborador,
              cônjuge e filhos menores que 14 anos.
            </li>
          </ul>
        </div>
      </div>

      <div className="w-full flex flex-col justify-center px-[7vw] max-[768px]:mt-14 mt-8">
        <h1 className="text-3xl text-blue-500 mb-4">
          toda história tem um bom começo!
        </h1>
        <p className="text-lg text-black mb-4">
          Foi assim que a Randstad surgiu: de uma grande ideia, através de uma
          bicicleta.
        </p>
        <p className="text-lg text-black mb-4">
          Foi de bike que nosso fundador, lá na Holanda em 1960, levou a
          primeira candidata à sua entrevista de emprego. Hoje, a Randstad é
          líder global em recrutamento e soluções completas de recursos humanos.
        </p>
        <p className="text-lg text-black">
          Nosso propósito é apoiar o maior número possível de pessoas a alcançar
          seu verdadeiro potencial ao longo de suas vidas profissionais. E temos
          a ambição de ser a empresa de talentos mais equitativa e especializada
          do mundo.
        </p>
      </div>

      <div
        className="w-full flex flex-col justify-center py-14 px-[7vw]"
        id="oportunidades"
      >
        <h1 className="text-3xl text-blue-500 mb-4">
          Quer uma oportunidade? Então faça sua inscrição!
        </h1>
        <div className="flex max-lg:flex-col justify-between max-lg:gap-4 w-full">
          <select
            onChange={onChangeFilterJobsCity}
            defaultValue=""
            className="max-lg:w-full filter-btn w-[350px] mb-4 p-2 cursor-pointer"
          >
            <option value="">Todas as cidades</option>
            {jobPositionCity.map((jobId, i) => (
              <option value={jobId.id} key={i}>
                {jobId.name} {jobId.stateCode ? `- ${jobId.stateCode}` : ""}
              </option>
            ))}
          </select>
          <select
            onChange={onChangeFilterJobsTitle}
            defaultValue=""
            className="max-lg:w-full filter-btn w-[350px] mb-4 p-2 cursor-pointer"
          >
            <option value="">Todas os cargos</option>
            {jobPositionTitle.map((jobId, i) => (
              <option value={jobId.id} key={i}>
                {jobId.name}
              </option>
            ))}
          </select>
        </div>
        {showLoader && (
          <div className="w-[90%] flex flex-col items-center mt-20 max-[768px]:w-full">
            <Spinner animation="grow" variant="primary" />
            <h4 className="text-[#3b82f6] mt-4">Carregando</h4>
          </div>
        )}
        {!showLoader && currentEffectiveJobs.length ? (
          <>
            <ul>
              {currentEffectiveJobs.map((job, i) => (
                <li className="jobs-list" key={i}>
                  <div className="w-[70%] pl-3 max-[768px]:w-full max-[768px]:p-0">
                    <p className="!m-0 max-[768px]:text-center">{job.name}</p>
                  </div>
                  <div className="w-[30%] flex justify-end max-[768px]:w-full max-[768px]:justify-center">
                    <Button
                      className="py-3 px-5 cursor-pointer self-end"
                      variant="primary"
                      href={job.shortUrl}
                      target="_blank"
                    >
                      candidatar-se
                    </Button>
                  </div>
                </li>
              ))}
            </ul>
            <ReactPaginate
              containerClassName="pagination"
              breakLabel="..."
              nextLabel="Próximo >"
              onPageChange={handlePageClickEffectiveJobs}
              marginPagesDisplayed={2}
              pageCount={pageCountEffectiveJobs}
              forcePage={currentPage}
              previousLabel="< Anterior"
              renderOnZeroPageCount={null}
            />
          </>
        ) : null}
        {!showLoader && !currentEffectiveJobs.length ? (
          <div className="jobs-list !justify-center">
            <h2 className="text-xl">
              Não encontramos resultados para sua busca.
            </h2>
          </div>
        ) : null}
      </div>

      <div className="bg-[#f7f5f0] px-[7vw] py-12">
        <div className="mb-12">
          <p className="text-black text-2xl mb-8">
            não encontrou uma vaga que combina com você?
          </p>
          <a
            href="https://www.randstad.com.br/guia-carreira/"
            target="_blank"
            className="border border-blue-500 text-blue-500 py-3 px-6 rounded-sm hover:bg-blue-500 hover:text-white transition"
            rel="noreferrer"
          >
            confira nossas vagas
          </a>
        </div>

        <div className="mb-12">
          <p className="text-black text-2xl mb-8">
            conheça mais sobre a Randstad
          </p>
          <a
            href="https://www.randstad.com.br/guia-carreira/"
            target="_blank"
            className="border border-blue-500 text-blue-500 py-3 px-6 rounded-sm hover:bg-blue-500 hover:text-white transition"
            rel="noreferrer"
          >
            sobre nós
          </a>
        </div>

        <div>
          <p className="text-black text-2xl mb-2">
            buscando dicas para a sua carreira?
          </p>
          <p className="text-[#2074D9] text-sm mb-8">
            Veja nosso blog e assista nossa webserie "Dicas de Carreira" no
            Youtube
          </p>
          <a
            href="https://www.randstad.com.br/guia-carreira/"
            target="_blank"
            className="border border-blue-500 text-blue-500 py-3 px-6 rounded-sm hover:bg-blue-500 hover:text-white transition"
            rel="noreferrer"
          >
            acesse nosso blog
          </a>
        </div>
      </div>

      <footer className="bg-[#2074D9] text-white py-8">
        <div className="container mx-auto flex flex-col items-center md:flex-row md:justify-between px-4">
          <div className="mb-4 md:mb-0">
            <img
              src="./assets/icons/Logo.png"
              alt="Randstad Logo"
              className="h-12"
            />
          </div>

          <div className="text-center md:text-left mb-4 md:mb-0">
            <p className="mb-2">
              Randstad Brasil Recursos Humanos LTDA é uma empresa registrada no
              Brasil sob CNPJ 03.573.863/000
            </p>
            <p>
              Escritório da matriz encontra-se na Av. Francisco Matarazzo, 1350,
              20º andar / CEP: 05001-100
            </p>
          </div>

          <div className="flex space-x-4">
            <a
              href="https://www.linkedin.com/company/randstad-brasil/"
              target="_blank"
              className="w-8 h-8 flex items-center justify-center"
              rel="noreferrer"
            >
              <img src="./assets/icons/linkedin-logo.png" alt="Linkedin Logo" />
            </a>
            <a
              href="https://www.youtube.com/user/randstadbrasil/featured"
              target="_blank"
              className="w-8 h-8 flex items-center justify-center"
              rel="noreferrer"
            >
              <img src="./assets/icons/youtube-logo.png" alt="Youtube Logo" />
            </a>
            <a
              href="https://www.facebook.com/RandstadBR/"
              target="_blank"
              className="w-8 h-8 flex items-center justify-center"
              rel="noreferrer"
            >
              <img src="./assets/icons/facebook-logo.png" alt="Facebook Logo" />
            </a>
            <a
              href="https://www.instagram.com/randstadbr/"
              target="_blank"
              className="w-8 h-8 flex items-center justify-center"
              rel="noreferrer"
            >
              <img
                src="./assets/icons/instagram-logo.png"
                alt="Instagram Logo"
              />
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
